import { Injectable } from '@angular/core';
import { StripeFactoryService, StripeInstance } from 'ngx-stripe';
import { AppFacade } from '../+store/app/app.facade';
import { environment } from '../../environments/environment';
import { StripeCardElement, StripeElements } from '@stripe/stripe-js';
import { map } from 'rxjs/operators';
import { retry } from '@care-portals/shared';

@Injectable({
  providedIn: 'root'
})
export class OrgStripeService {
  stripe: StripeInstance;
  elements: StripeElements;
  card: StripeCardElement;

  constructor(
    private appFacade: AppFacade,
    private stripeFactory: StripeFactoryService
  ) {
    this.appFacade.layout$.subscribe(layout => {
      const key = layout?.stripePublicKey;
      if (!key) {
        return;
      }
      this.stripe = this.stripeFactory.create(
        key || environment.stripe.publicKey
      );
    });
  }

  initElements(callback?: (card: StripeCardElement) => void) {
    this.stripe
      .elements({
        locale: 'auto'
      })
      .subscribe(elements => {
        this.elements = elements;
        this.card = this.elements.create('card', {
          style: {
            base: {
              iconColor: '#D1837E',
              color: '#000',
              fontFamily: 'inherit',
              fontWeight: 400,
              fontSize: '16px',
              fontSmoothing: 'antialiased',

              '::placeholder': {
                color: '#757575'
              },
              ':-webkit-autofill': {
                color: '#909090'
              }
            },
            invalid: {
              iconColor: '#FF93CE',
              color: '#FF93CE'
            }
          }
        });

        retry(() => {
          this.card.mount('#stripe-card-element');
        }).then(() => callback?.(this.card));
      });
  }

  getCardElement(): StripeCardElement {
    return this.card;
  }

  tokenize() {
    // return this.stripe.createToken(this.card)
    return this.stripe
      .createPaymentMethod({
        type: 'card',
        card: this.card
      })
      .pipe(
        map(({ paymentMethod, error }) => {
          if (paymentMethod && !error) {
            return paymentMethod;
          } else {
            // Error creating the token
            console.error(error.message);
            throw new Error(error.message);
          }
        })
      );
  }
}
